import { Spinner as ChakraSpinner } from '@chakra-ui/react';
import { SpinnerHolder } from '../../../styles/ListingsStyles';

const Spinner = ({ size }) => (
    <SpinnerHolder>

        <ChakraSpinner size={size} color="green.800" />
    </SpinnerHolder>
);

export default Spinner;